import { Form, Formik, useFormikContext } from "formik";
import React, { FC, useCallback, useEffect, useState } from "react";
import Modal from 'react-modal';
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import Wizard from "../wizard/wizard";
import { WizardSummaryContext } from "../wizard/wizardSummaryContext";
import { WizardContentForm } from "./wizardContents";
import { WizardDescription } from "./wizardDescription";
import { WizardSummary } from "./wizardSummary";

interface DataFilterWizardProps {
    isOpen: boolean;
    title: string;
    onClose: () => void;
    onSave: (dataFilters, createNew) => void;
    currentItem: any
}

export const DataFilterWizard: FC<DataFilterWizardProps> = ({ isOpen, title, onClose, onSave, currentItem }) => {
    const [summary, setSummary] = useState(new Array(0));
    const [step, setStep] = useState(0);
    const { translate } = useLocale();

    const initialSidebarSteps = [{
        title: translate.byKey(TranslationKeys.dataFilters),
        description: '',
        substeps: []
    }, {
        title: translate.byKey(TranslationKeys.details),
        description: '',
        substeps: []
    }, {
        title: translate.byKey(TranslationKeys.summary),
        description: '',
        substeps: []
    }];
    const [sidebarSteps, setSidebarSteps] = useState(initialSidebarSteps);

    useEffect(() => {
        (async () => {
            setSummary(new Array(0));
        })();
    }, [isOpen === true])

    const handleClose = () => {
        setSidebarSteps(initialSidebarSteps);
        setStep(0);
        onClose();
    }

    const handleSubmit = (userPreference) => {
        onSave(userPreference, true);
        handleClose();
    };

    const setSideBarStepDescription = (index, event) => {
        const newSideBarSteps = sidebarSteps.map((step, stepIndex) => {
            return { ...step, description: stepIndex === index ? event.itemName : step.description };
        });
        setSidebarSteps(newSideBarSteps);
        setStep(step + 1);
    }

    const contentPages = [
        <WizardDescription
            key={"wizard-1"}
            onBack={handleClose}
            onNext={(event) => setSideBarStepDescription(0,event)}>
        </WizardDescription>,
        <WizardContentForm
            key={"wizard-2"}
            onNext={(event) => setSideBarStepDescription(1,event)}
            onBack={() => setStep(step - 1)}>
        </WizardContentForm>,
        <WizardSummary
            key={"wizard-3"}
            onBack={() => setStep(step - 1)}>
        </WizardSummary>
    ];

    const updateSummary = (accessor: string, newDisplayValue: string) => {
        if (summary) {
            const existingSummaryEntryIndex = summary.findIndex(item => item.value === accessor);
            const newSummaryEntry = { value: accessor, label: newDisplayValue };
            if (existingSummaryEntryIndex >= 0) {
                summary.splice(existingSummaryEntryIndex, 1, newSummaryEntry);
            }
            else {
                summary.push(newSummaryEntry);
            }
        }
    }

    const getContextValue = useCallback(
        () => (
            {
                summary: [...summary],
                updateSummary
            }
        ),
        [summary, setSummary],
    )

    return <WizardSummaryContext.Provider value={getContextValue()}>
        <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
            className="bg-white border-none m-auto shadow select-none outline-none w-content">
            <Formik
                initialValues={currentItem}
                onSubmit={handleSubmit}
                enableReinitialize={true}>
                <Form>
                    <Wizard
                        name={title}
                        onClose={handleClose}
                        step={step}
                        sidebarSteps={sidebarSteps}>
                        {contentPages}
                    </Wizard>
                </Form>
            </Formik>
        </Modal>
    </WizardSummaryContext.Provider>;
};
